import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SectionHeading from "./SectionHeading";
import axiosInstance from "../../../utils/axios";
import bottom_right_cardIcon from "../../../Assets/Images/home/domains/bottom_right_icon.png";
const ProgrammeCardSkeleton = () => {
  return (
    <div className="relative bg-gray-200/40 rounded-xl shadow-sm overflow-hidden animate-pulse h-64">
      {/* Top image area */}
      <div className="h-32 w-full bg-gray-300/60"></div>

      {/* Text placeholders */}
      <div className="p-4 space-y-3">
        <div className="h-4 w-3/4 bg-gray-300/60 rounded"></div>
        <div className="h-3 w-1/2 bg-gray-300/50 rounded"></div>
      </div>

      {/* bottom-right icon placeholder */}
      <div className="absolute bottom-3 right-3 h-8 w-8 bg-gray-300/50 rounded-full"></div>
    </div>
  );
};

// Parent Component
const AFSAProgrammes = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axiosInstance
      .get(`/services/all-services`)
      .then((res) => {
        setServices(res.data);
      })
      .catch((err) => {
        console.error("Failed to fetch services:", err);
      })
      .finally(() => setLoading(false));
  }, []);
  return (
    <div className="general-p-m">
      <SectionHeading subtitle={"AAFSA’S Domains"} title={"Our Programmes"} />

      {/* Grid Layout */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 pt-10">
        {loading
          ? Array.from({ length: 6 }).map((_, i) => (
              <ProgrammeCardSkeleton key={i} />
            ))
          : services
              .slice(0, 6)
              .map((programme, index) => (
                <ProgrammeCard key={index} {...programme} index={index + 1} />
              ))}
      </div>
    </div>
  );
};

export default AFSAProgrammes;

const ProgrammeCard = ({
  cardIcon,
  cardBgColor,
  serviceName,
  subtitle,
  _id,
  sdgNumber,
  sequenceNo,
  index,
}) => {
  return (
    <Link to={`/services/${_id}`}>
      <div className="flex flex-col w-full mx-auto">
        <div className="h-16 w-full"></div>
        <div
          className={`flex flex-col relative h-full min-h-[10rem] rounded-2xl shadow-md p-6 transition-all ease-in-out hover:scale-[101%] hover:shadow-xl cursor-pointer`}
          style={{ backgroundColor: cardBgColor }}
          data-aos="fade-up"
          data-aos-delay={index * 100} // stagger effect (100ms per card)
          data-aos-anchor-placement="top-bottom"
        >
          {/* cardIcon */}
          <div className="bg-white overflow-hidden absolute size-[6rem] sm:size-[7rem] md:size-[8rem] flex items-center justify-center top-0 right-[10%] translate-y-[-50%] rounded-full shadow-xl border-t border-black border-opacity-10 drop-shadow-xl transition-transform duration-200 ease-in-out">
            {cardIcon ? (
              <img
                src={cardIcon}
                alt="cardIcon"
                className="w-16 sm:w-20 md:w-auto"
              />
            ) : (
              <span className="text-gray-400 text-sm">No icon</span>
            )}
          </div>

          <img
            src={bottom_right_cardIcon}
            className="absolute bottom-0 right-0 w-32"
            alt="bottom_right_cardIcon"
          />

          {/* Filler */}
          <div className="h-10"></div>

          {/* Content */}
          <div className="h-full">
            <h3 className="text-[#5C5C5C] text-[1.16rem] md:text-[1.3rem]">
              SDG- {sdgNumber}
            </h3>

            <div className="flex flex-col min-h-[5rem] md:min-h-[8rem]">
              {/* <h3 className="text-xl md:text-2xl font-semibold md:max-w-[20rem] text-wrap text-[#08121A]"> */}
              <h3 className="text-xl md:text-2xl font-semibold md:max-w-full text-wrap text-[#08121A]">
                {serviceName}
              </h3>
              {subtitle && (
                <p className="py-1 text-gray-700 text-base md:text-lg line-clamp-2 text-wrap">
                  {subtitle}
                </p>
              )}
            </div>

            <span className="text-sm md:text-base font-medium text-[#C23F00] hover:underline">
              More Details →
            </span>
          </div>
        </div>
      </div>
    </Link>
  );
};

// Reusable Card Component
// const ProgrammeCard = ({ cardIcon, cardBgColor, serviceName, _id, index }) => {
//   return (
//     <Link to={`/services/${_id}`}>
//       <div className="flex flex-col">
//         <div className="h-16 w-full"></div>
//         <div
//           className={`flex flex-col relative h-full  min-h-[10rem] rounded-2xl shadow-md p-6 transition-all ease-in-out hover:scale-[101%] hover:shadow-xl cursor-pointer`}
//           style={{ backgroundColor: cardBgColor }}
//           data-aos="fade-up"
//           data-aos-delay={index * 100} // stagger effect (100ms per card)
//           data-aos-anchor-placement="top-bottom"
//         >
//           {/* cardIcon */}
//           <div className="bg-white overflow-hidden absolute size-[6rem] sm:size-[7rem] md:size-[8rem] flex items-center justify-center top-0 right-[10%] translate-y-[-50%]  rounded-full shadow-xl border-t border-black border-opacity-10  drop-shadow-xl transition-transform duration-200 ease-in-out">
//             <img
//               src={cardIcon}
//               alt="cardIcon"
//               className="w-16 sm:w-20 md:w-auto"
//             />
//           </div>
//           <img
//             src={bottom_right_cardIcon}
//             className="absolute bottom-0 right-0 w-32"
//             alt="bottom_right_cardIcon"
//           />

//           {/* Filler */}
//           <div className="h-10"></div>
//           <div className="h-full">
//             <h3 className="text-[#5C5C5C] text-[1.26rem] md:text-[1.4rem]">
//               Domain {index}
//             </h3>

//             <h3 className="text-2xl md:text-3xl font-semibold  md:max-w-[20rem] min-h-[4rem] md:min-h-[7rem] text-wrap text-[#08121A] ">
//               {serviceName}
//             </h3>

//             <Link
//               to={`/services/${_id}`}
//               className="text-sm md:text-base font-medium text-[#C23F00] hover:underline"
//             >
//               More Details →
//             </Link>
//           </div>
//         </div>
//       </div>
//     </Link>
//   );
// };
